import { render } from "./ObjectListField.vue?vue&type=template&id=644ecf20&scoped=true"
import script from "./ObjectListField.vue?vue&type=script&lang=js"
export * from "./ObjectListField.vue?vue&type=script&lang=js"

import "./ObjectListField.vue?vue&type=style&index=0&id=644ecf20&lang=scss"
import "./ObjectListField.vue?vue&type=style&index=1&id=644ecf20&lang=scss&scoped=true"

import exportComponent from "/app/tmp/blackhall/V3/v2025.48.r2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-644ecf20"]])

export default __exports__